import React from 'react';
import { CheckIcon, MessageCircleIcon } from 'lucide-react';
import { useSeo } from '../utils/seo';
import { VenderAutoForm } from '../components/forms/VenderAutoForm';
import { ButtonAnchor } from '../components/ui/Button';
import { GENERAL_WA_MESSAGE, whatsappLink } from '../utils/vehicles';
import { SELL_IMAGE } from '../data/vehicles';
const pasos = ['Analizamos tu unidad y definimos el precio de publicación', 'Tomamos fotos e información completa del vehículo', 'Publicamos y promocionamos en nuestros canales', 'Filtramos interesados reales y coordinamos consultas', 'Negociamos con asesoramiento profesional', 'Te acompañamos hasta el cierre de la operación'];
const beneficios = ['Mayor exposición', 'Atención profesional', 'Menos pérdida de tiempo', 'Mejor presentación del vehículo', 'Acompañamiento comercial', 'Operación más segura'];
export function VenderAuto() {
  useSeo('Vendé tu auto con VCARS | Gestión profesional de la venta', 'Publicamos, promocionamos y gestionamos la venta de tu auto: filtramos interesados y te acompañamos hasta el cierre.');
  return <main className="bg-ink" data-id="element-529" data-mp="3dn7dighh8qzd">
      <div className="border-b border-line bg-surface" data-id="element-530" data-mp="3dlwawjzrpp9u">
        <div className="mx-auto w-full max-w-7xl px-5 py-14 md:px-8 md:py-20" data-id="element-531" data-mp="39ngrsr6t511p">
          <div className="grid gap-10 lg:grid-cols-[1fr_1fr] lg:gap-16" data-id="element-532" data-mp="34nudeef8terb">
            <div data-id="element-533" data-mp="34lhp7jiw685t">
              <h1 className="text-4xl font-black leading-[1.05] tracking-tight text-white md:text-[52px]" data-id="element-534" data-mp="57xi1r83ek0k">
                Vendé tu auto con VCARS
              </h1>
              <p className="mt-5 text-lg font-semibold text-white/90" data-id="element-535" data-mp="14hj2o8jw7kp">
                Nosotros gestionamos la venta de tu auto por vos.
              </p>
              <p className="mt-3 max-w-xl text-base leading-relaxed text-mist" data-id="element-536" data-mp="3ncqwrn93qmur">
                Publicamos, promocionamos, filtramos interesados, coordinamos consultas y
                te acompañamos durante la operación.
              </p>
              <div className="mt-8 overflow-hidden rounded-2xl border border-line" data-id="element-537" data-mp="2c0q3pw57gc97">
                <img src={SELL_IMAGE} alt="Fotografía profesional de un vehículo en el estudio de VCARS" className="h-64 w-full object-cover md:h-80" data-id="element-538" data-mp="2dgc41oyyc5s7" />
              </div>
              <ul className="mt-6 grid grid-cols-2 gap-x-6 gap-y-3" data-id="element-539" data-mp="29dyvytwqfvs9">
                {beneficios.map(b => <li key={b} className="flex items-start gap-2 text-sm text-white/90" data-id="element-540" data-mp="1uosxj85py9lf">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-neon" aria-hidden="true" data-id="element-541" data-mp="1zfriwm5kdxvj" />
                    {b}
                  </li>)}
              </ul>
              <ButtonAnchor href={whatsappLink(GENERAL_WA_MESSAGE)} variant="whatsapp" size="lg" className="mt-8" data-id="element-542" data-mp="1lmthai2j39jj">
                <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-543" data-mp="1bst4du109009" />
                Hablar con un vendedor
              </ButtonAnchor>
            </div>

            <div data-id="element-544" data-mp="x4jco97wvfz6">
              <h2 className="text-xl font-bold text-white" data-id="element-545" data-mp="x402xfsezxw8">
                Cómo funciona la venta particular gestionada
              </h2>
              <ol className="mt-6 space-y-5 border-l border-line pl-8" data-id="element-546" data-mp="171o1yhx1zrk7">
                {pasos.map((p, i) => <li key={p} className="relative" data-id="element-547" data-mp="122l5vmz1wvod" data-mpi={i}>
                    <span className="absolute -left-[45px] grid h-8 w-8 place-items-center rounded-full border border-neon/40 bg-ink text-[13px] font-bold text-neon" data-id="element-548" data-mp="124xmnwt2ozzu">
                      {i + 1}
                    </span>
                    <p className="text-[15px] leading-relaxed text-white/90" data-id="element-549" data-mp="1psfe1r8fdw2a">{p}</p>
                  </li>)}
              </ol>
            </div>
          </div>
        </div>
      </div>

      <section className="mx-auto w-full max-w-4xl px-5 py-16 md:px-8" data-id="element-550" data-mp="1yt3mm6f1v47s">
        <VenderAutoForm data-id="element-551" data-mp="1yr0wlmdwdb32" />
      </section>
    </main>;
}